import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { HeaderBg } from 'images/subcontracting';
import { SubcontractingFormSection } from 'containers/forms';

const AboutUs: NextPage = () => {
  return (
    <>
      <Header
        title="Subcontracting Opportunities"
        description="Looking for subcontracting opportunities that work for you? Here are the right opportunities for your professional needs."
        image={HeaderBg}
      />
      <SubcontractingFormSection />
    </>
  );
};

export default AboutUs;
